import { EquipmentDocument } from '../Equipment/queryBuilder';
import { InspectionDocument } from '../Inspections/queryBuilder';
import { LocationDocument } from '../Locations/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  GroundHazardDocument,
  groundHazardPullModifier,
  groundHazardPushQueryBuilder,
  groundHazardsPullQueryBuilder,
} from './queryBuilder';

export function groundHazardsFamilyMember(
  configBuilder: ConfigBuilder,
  equipment: FamilyMember<EquipmentDocument>,
  inspections: FamilyMember<InspectionDocument>,
  locations: FamilyMember<LocationDocument>,
): FamilyMember<GroundHazardDocument> {
  const syncConfig = configBuilder<GroundHazardDocument>(RxdbCollectionNameV2.GROUND_HAZARDS);
  doNotAutoSync(syncConfig);

  const pullConfig = pull(syncConfig, groundHazardsPullQueryBuilder);
  pullConfig.modifier = groundHazardPullModifier;

  push(syncConfig, groundHazardPushQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.GROUND_HAZARDS, replicationState, [
    equipment,
    inspections,
    locations,
  ]);
}
